import request from '../request'

export default {
  getRegions: function () {
    return request.get('regions')
  },
  /* createRegion: function (region) {
    return request.post('regions', region)
  }, */
  createRegion: function (formData, progressCallback) {
    const config = {
      onUploadProgress: progressEvent => {
        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        progressCallback(percentage)
      },
      timeout: 1000 * 60 * 5
    }
    return request.post('regions', formData, config)
  },
  deleteRegion: function (region) {
    return request.delete(`regions/${region.ID_REGION}`)
  },
  getRegionStatus: function (idRegion) {
    return request.get('regions/getRegionStatus', {
      params: {
        ID_REGION: idRegion
      }
    })
  }
}
